import { Injectable } from '@angular/core';
import moment from 'moment';
import { LoadingController, AlertController, Platform } from 'ionic-angular';
import { Http, Headers } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import 'rxjs/add/operator/map';
import { AppVersion } from '@ionic-native/app-version';
import numeral from 'numeral';
import { CustomizerProvider } from './customizer/customizer';
export class ProductVariants {
    /**
     * @member ingredients is the reference to local array of ingredients
     * @member variants is the reference to local array of variants
     * @member max is a value set to max variants when structure is used as a return value
     */
    public ingredients = [];
    public variants = [];
    public max? = 0;
    public mandatoryIngredients? = [];
}

@Injectable()
export class provider {
    loading: any;
    data: any;
    restaurant: any;
    token: any;
    idTavolo: any;
    cart = [];
    message: any;
    resp: any;
    menu_tms: any;
    libIdx = {};
    menuRowsIdx = {};
    tot: any;
    client_id: any;
    form;
    selectedLocale = false;
    sfogliamenu = false;
    temporaryCustomer: object;
    firstOrder = false;
    chosenDate: string;
    dataInfo: any;
    prepaidcard: boolean;
    coupon: boolean;
    couponsApplied = [];

    constructor(
        public http: Http,
        public loadingCtrl: LoadingController,
        public storage: Storage,
        public alertCtrl: AlertController,
        public appVersion: AppVersion,
        public translateService: TranslateService,
        public platform: Platform,
        public customizer: CustomizerProvider
    ) {
        this.storage.get('client_id').then((id) => {
            if (id) {
                this.client_id = id;
            }
        });

        this.loading = this.loadingCtrl.create({
            content: '<ion-spinner></ion-spinner>',
        });

        if (!this.platform.is('core')) {
            this.platform.ready().then(() => {
                const msg = {
                    ATTENZIONE: 'Attenzione !',
                    UPDATE_AVAILABLE: "C'è un aggiornamento disponibile",
                    SERVER_UNAVAILABLE: 'Errore di collegamento al server',
                };
                this.appVersion
                    .getPackageName()
                    .then((appBundleId) => {
                        this.appVersion
                            .getVersionNumber()
                            .then((appVersionCode) => {
                                this.http
                                    .get(`https://api.tapmenu.it/api-url/check-update/${appBundleId}/${appVersionCode}`)
                                    .map((res) => res.json())
                                    .subscribe((data) => {
                                        let alert = this.alertCtrl.create({
                                            enableBackdropDismiss: false,
                                            title: msg.ATTENZIONE,
                                            subTitle: msg.UPDATE_AVAILABLE,
                                            buttons: [
                                                {
                                                    text: 'Ok',
                                                    role: null,
                                                    handler: () => {
                                                        if (this.platform.is('mobile')) {
                                                            this.appVersion
                                                                .getPackageName()
                                                                .then((pack) => {
                                                                    this.getStoreUrl(pack).then((url) => {
                                                                        // open store url
                                                                        window.open(url, '_system');
                                                                    });
                                                                })
                                                                .catch(function (err) {
                                                                    console.log('PackageName' + err);
                                                                });
                                                        } else {
                                                            // we are on fixed platform
                                                            location.reload();
                                                        }
                                                        return false;
                                                    },
                                                },
                                            ],
                                        });
                                        if (data.update) {
                                            alert.present();
                                        }
                                    });
                            })
                            .catch(function (err) {
                                console.log('VersionNumber' + err);
                            });
                    })
                    .catch(function (err) {
                        console.log('PackageName' + err);
                    });
            });
        }
    }

    private buildAuthHeaders(content_type: string = null) {
        let headers = new Headers();
        if (this.token != null) headers.append('Authorization', 'Bearer ' + this.token);
        if (this.client_id) headers.append('client_id', this.client_id);
        if (content_type != null) headers.append('Content-Type', content_type);
        return headers;
    }

    getMenuExpired() {
        return moment.duration(moment().diff(this.menu_tms)).asHours() >= 1;
    }

    getUrl() {
        return this.customizer.getApiURL().toString();
    }

    getTable(url) {
        if (this.data) {
            return Promise.resolve(this.data);
        }
        return new Promise((resolve) => {
            this.http.get(url).subscribe(
                (data) => {
                    resolve(data);
                },
                (error) => {
                    resolve(error);
                }
            );
        });
    }

    setTable(table) {
        this.token = table;
    }

    setSfogliamenu() {
        this.sfogliamenu = true;
    }

    isSfogliamenu() {
        return this.sfogliamenu;
    }

    /*
     * getTemporaryCustomer
     * restituisce l'eventuale cliente "volante" recuperato dalla
     * web-app
     */
    getTemporaryCustomer() {
        return this.temporaryCustomer;
    }

    /*
     * setTemporaryCustomer(temporaryCustomer)
     * imposta il cliente "volante" recuperato dalla
     * web-app
     */
    setTemporaryCustomer(temporaryCustomer) {
        this.temporaryCustomer = temporaryCustomer;
    }

    getToken() {
        return this.token;
    }

    /**
     * Get activeMenu from server based on optional arguments
     * @param when is the timestamp of the menu to be fetched
     * @param how is the mode (home/shop) to be fetched
     */
    getData(when?: string, how?: string) {
        let headers = this.buildAuthHeaders();

        if (this.data) {
            // use cached results
            return Promise.resolve(this.data);
        }

        return new Promise((resolve) => {
            // build url based on "when" and "how"
            const url =
                when == undefined && how == undefined
                    ? `${this.customizer.getApiURL()}/menu/get-active`
                    : `${this.customizer.getApiURL()}/menu/get-active/${when}/${how}`;

            this.http
                .get(url, { headers: headers })
                .map((res) => res.json())
                .subscribe(
                    (data) => {
                        this.idTavolo = data.tavolo._id;
                        this.menu_tms = moment();
                        this.data = data;
                        // populate indexes
                        this.menuRowsIdx = {};
                        this.data.menu.righe.map((riga: any) => {
                            this.menuRowsIdx[riga._id] = riga;
                        });
                        this.libIdx = {};
                        this.data.lib.map((product: any) => {
                            this.libIdx[product._id] = product;
                        });
                        // sort menu rows
                        this.data.menu.righe.sort(function (a, b) {
                            return a.ordering - b.ordering;
                        });
                        // flush cart
                        this.deleteCart();
                        resolve(this.data);
                    },
                    (err) => {
                        resolve(err);
                    },
                    () => {
                        this.loading.dismiss();
                    }
                );
        });
    }

    checkMenu(when: string, how: string, menuId: boolean) {
        let headers = this.buildAuthHeaders();
        return this.http.get(this.customizer.getApiURL() + `/menu/get-active/${when}/${how}/${menuId}`, { "headers": headers });
    }

    getDataInfo() {
        if (this.dataInfo) {
            return this.dataInfo;
        }
        let headers = this.buildAuthHeaders();
        this.dataInfo = this.http.get(this.customizer.getApiURL() + "/menu/get-active", { "headers": headers });
        return this.dataInfo;
    }

    /**
     * Deep clone an object by jsonifying it and reparsing back to object
     * @param obj the object to be cloned
     * @returns a deep copy of the first object
     */
    public deepCloneObject(obj: object): object {
        return JSON.parse(JSON.stringify(obj));
    }

    /**
     * Get a product from library, creating a deep-clone of if and setting quantity to 0
     * @param id the of object to be cloned
     * @returns the new object as copy of the original one or null if it doesn't exists in library
     */
    public getProduct(id: string): object {
        let libraryObject: any = this.libIdx.hasOwnProperty(id) ? this.deepCloneObject(this.libIdx[id]) : null;
        // clear quantity if object is valid
        if (libraryObject) libraryObject.quantita = 0;
        return libraryObject;
    }

    /**
     * Get a menu row creating a deep-clone of it
     * @param id the menurow id to be cloned
     * @returns the new menurow as a clone of the original or null if it doesn't exists in menu
     */
    public getMenuRow(id: string): object {
        return this.menuRowsIdx.hasOwnProperty(id) ? this.deepCloneObject(this.menuRowsIdx[id]) : null;
    }

    /**
     * Get menurows child for a menurow
     * @param id the id of the parent menurow to be looked at
     * @returns an array of menurows child of the parent one
     */
    public getMenuChildRows(id: string): object[] {
        let parent = this.getMenuRow(id);
        let result = [];
        if (parent) result = this.data.menu.righe.filter((riga) => riga.parent == id).map((riga) => this.deepCloneObject(riga));
        return result;
    }

    sbloccaTavolo(tavolo, cod) {
        let headers = this.buildAuthHeaders();
        return this.http.get(this.customizer.getApiURL() + '/tavoli/verifica-codice/' + tavolo + '/' + cod, { headers: headers });
    }

    setCard(phone, cod, id) {
        return this.http.post(this.customizer.getApiURL() + '/cards/match/', { phone: phone, otc: cod, ownerId: id });
    }

    getCardBalance(hash) {
        let headers = this.buildAuthHeaders();
        return this.http.post(this.customizer.getApiURL() + '/cards/balance/', { hash: hash }, { headers: headers });
    }

    cardsBackup(phone, id) {
        return this.http.post(this.customizer.getApiURL() + '/cards/backup/', { telephone: phone, ownerId: id });
    }

    /**
     * Get the loaded menu
     * @returns the loaded menu from server
     */
    getMenu(): any {
        return this.data;
    }

    //calculate the total of the order
    getTotal(ordine, nRiga) {
        let calcolo = eval(this.data.calcolo);
        return calcolo(ordine, numeral, nRiga);
    }

    setTotal(tot) {
        this.tot = tot;
    }

    renderDescr(obj) {
        return (
            (obj.descrizione.find((descr) => descr.lingua == this.translateService.currentLang.toUpperCase()) || { contenuto: false })
                .contenuto || (obj.descrizione.find((descr) => descr.main) || { contenuto: 'NO DESCRIZIONE' }).contenuto
        );
    }

  renderDescrEstesa(obj) {  
        return (
            (obj.descrizioneEstesa.find((descr) => descr.lingua == this.translateService.currentLang.toUpperCase()) || { contenuto: false })
                .contenuto || (obj.descrizioneEstesa.find((descr) => descr.main) || { contenuto: 'NO DESCRIZIONE' }).contenuto
        ).replace(/\n/g, '<br />');
    }

    /**
     * Adapt cart items to be used for the "eval" of price
     * @param cart is the cart reference
     */
    transformCart(cart) {
        let righe = [];
        cart.map((item) => {
            // map variants
            let varianti = [];
            item.varIngr
                .filter((variant) => variant.quantita != 0)
                .map((variant) => {
                    let descrizione = '';
                    variant.descrizione
                        .filter((description) => description.main)
                        .map((description) => {
                            descrizione = description;
                        });
                    varianti.push({
                        _id: variant._id,
                        ctvlx: variant.ctvlx,
                        prezzo: variant.prezzo,
                        quant: variant.quantita,
                        descrizione: descrizione,
                        extraProps: variant.extraProps,
                    });
                });
            // then item
            let itemDescription = '';
            item.prodotto.content.descrizione
                .filter((description) => description.main)
                .map((description) => {
                    itemDescription = description;
                });
            righe.push({
                quant: item.quantita,
                _id: item.prodotto._id,
                updatedAt: item.prodotto.updatedAt,
                prod: {
                    _id: item.prodotto.content._id,
                    ctvlx: item.prodotto.content.ctvlx,
                    prezzo: item.prodotto.content.prezzo,
                    varIngr: varianti,
                    updatedAt: item.prodotto.content.updatedAt,
                    descrizione: itemDescription,
                },
            });
        });
        this.tot = this.getTotal(righe, null);
    }

    //add item to the cart
    addToCart(item) {
        this.cart.push(item);
        this.transformCart(this.cart);
    }

    //get cart
    getCart() {
        return this.cart;
    }

    //get totale
    showTotal() {
        return this.tot;
    }

    /**
     * Update a product instance in cart
     * @param prod the product to update in cart
     */
    updateCartItem(prod) {
        for (let i = 0; i < this.cart.length; i++) {
            if (this.cart[i].id == prod.id) {
                // update object and exit
                this.cart[i] = prod;
                break;
            }
        }
    }

    /**
     * Delete whole cart
     */
    deleteCart() {
        this.cart.length = 0;
        this.tot = 0;
    }

    /**
     * Delete an item from cart based on its id
     * @param id is the cart id
     */
    deleteItemCart(id) {
        let newCart = this.cart.filter((item) => item.id != id);
        this.cart.length = 0;
        newCart.map((item) => this.cart.push(item));
        this.transformCart(this.cart);
    }

    clearApp() {
        this.token = null;
        this.data = null;
        this.dataInfo = null;
        this.deleteCart();
    }

    postOrdini(hash, how, when, righeOrdine, customer, takeaway, version, appVersion, totalFromServer) {
        let fd = new FormData();
        let headers = this.buildAuthHeaders();
        fd.append(
            'data',
            JSON.stringify({
                righe: righeOrdine,
                hash: hash,
                paymentType: { how: how, when: when },
                deliveryCustomer: customer == null ? customer : customer._id,
                note: customer == null ? null : takeaway.note,
                deliveryAddress: customer == null ? null : takeaway.address,
                deliveryMode: customer == null ? null : takeaway.mode,
                deliverySchedule: customer == null ? null : takeaway.schedule,
                deliveryPlace: customer == null ? null : takeaway.place,
                fcmID: customer == null ? customer : customer.fcmID,
                version: version,
                appVersion: appVersion,
                tfs: totalFromServer
            })
        );

        return this.http.post(this.customizer.getApiURL() + '/ordini', fd, { headers: headers });
    }

    getOrdiniCheck(ordineID) {
        let headers = this.buildAuthHeaders();
        return this.http.get(this.customizer.getApiURL() + '/ordini/check/' + ordineID, { headers: headers });
    }

    phoneCall(form) {
        this.form = form;
        let headers = this.buildAuthHeaders('application/json');
        let fd = JSON.stringify({ number: form.telephone, firstName: form.firstName, lastName: form.lastName });
        return this.http.post(this.customizer.getUserDatabaseURL() + '/v2/phoneCall', fd, { headers: headers });
    }

    phoneSMS(form) {
        this.form = form;
        let headers = this.buildAuthHeaders('application/json');
        let fd = JSON.stringify({ number: form.telephone, firstName: form.firstName, lastName: form.lastName });
        return this.http.post(this.customizer.getUserDatabaseURL2() + '/sms', fd, { headers: headers });
    }

    register(code) {
        let headers = this.buildAuthHeaders('application/json');
        this.form.code = code;
        let fd = JSON.stringify(this.form);
        return this.http.post(this.customizer.getUserDatabaseURL().toString() + '/v2/post', fd, { headers: headers });
    }

    login(form) {
        let headers = this.buildAuthHeaders('application/json');
        let fd = JSON.stringify(form);
        return this.http.post(this.customizer.getUserDatabaseURL() + '/login', fd, { headers: headers });
    }

    edit(form) {
        let headers = this.buildAuthHeaders('application/json');
        let fd = JSON.stringify(form);
        return this.http.put(this.customizer.getUserDatabaseURL() + '/' + form.id, fd, { headers: headers });
    }

    delete(id) {
        let headers = this.buildAuthHeaders('application/json');
        return this.http.delete(this.customizer.getUserDatabaseURL() + '/' + id, { headers: headers });
    }

    getCustomer(id) {
        let headers = this.buildAuthHeaders('application/json');
        return this.http.get(this.customizer.getUserDatabaseURL() + '/' + id, { headers: headers });
    }

    getCities() {
        const loading = this.loadingCtrl.create({
            content: '<ion-spinner name="circles"></ion-spinner>'
        });

        loading.present().then(() => {
            this.http.get(this.customizer.getApiURL() + '/cities/it').subscribe(
                (result) => {
                    sessionStorage.setItem('comuni', (<any>result)._body);
                    loading.dismiss();
                },
                (err) => {
                    loading.dismiss();
                    console.log(err);
                }
            );
        });
    }

    getShops(code) {
        let headers = this.buildAuthHeaders('application/json');
        return this.http.get(this.customizer.getApiURL() + '/users/city-restaurants/' + code, { headers: headers });
    }

    getJWTAsporto(id) {
        let headers = this.buildAuthHeaders('application/json');
        return this.http.get(this.customizer.getApiURL() + '/customers/generate-order-jwt/' + id, { headers: headers });
    }

    getSlots(from: String = undefined, mode: String = undefined) {
        let headers = this.buildAuthHeaders('application/json');
        return this.http.get(
            this.customizer.getApiURL() +
                (from != undefined ? `/orders/slotsByDeliveryMode/${mode}/${from}` : '/orders/slotsByDeliveryMode'),
            { headers: headers }
        );
    }

    getWorkingDays() {
        let headers = this.buildAuthHeaders('application/json');
        return this.http.get(this.customizer.getApiURL() + '/orders/workingDays', { headers: headers });
    }

    updateFCMID(id, fcmID) {
        let headers = this.buildAuthHeaders('application/json');
        return this.http
            .patch(this.customizer.getUserDatabaseURL() + '/fcm-id/' + id, JSON.stringify({ fcmID: fcmID }), { headers: headers })
            .toPromise();
    }

    getNearCountry(latitude, longitude) {
        let headers = this.buildAuthHeaders('application/json');
        return this.http.get(this.customizer.getApiURL() + '/cities/near/' + latitude + '/' + longitude, { headers: headers });
    }

    verifyEmail(email) {
        let headers = this.buildAuthHeaders();
        return this.http.post(this.customizer.getApiURL() + '/customers/verify-email/', {email: email}, { headers: headers });
    }

    getPrivacy() {
        // let headers = this.buildAuthHeaders('application/json');
        return this.http.get('https://www.iubenda.com/api/privacy-policy/51897710/no-markup');
    }

    changePassword(id, customer) {
        let headers = this.buildAuthHeaders('application/json');
        return this.http.patch(
            this.customizer.getUserDatabaseURL() + '/password/' + id,
            JSON.stringify({ password: customer.password, confirmPassword: customer.confirmPassword }),
            { headers: headers }
        );
    }

    recoverPassword(email) {
        let headers = this.buildAuthHeaders('application/json');
        return this.http.get(this.customizer.getUserDatabaseURL() + '/recover-email/' + email, { headers: headers });
    }

    getStoreUrl(appBundleId: String): Promise<string> {
        let result = new Promise<string>((resolve, reject) => {
            if (this.platform.is('android')) resolve(`https://play.google.com/store/apps/details?id=${appBundleId}`);
            else {
                // fetch trackId from Apple Store
                this.http
                    .get(`https://itunes.apple.com/lookup?bundleId=${appBundleId}`)
                    .map((res) => res.json())
                    .subscribe((data) => {
                        if (data.resultCount > 0) {
                            const appId = data.results[0].trackViewUrl;
                            resolve(appId);
                        }
                    });
            }
        });
        return result;
    }

    /**
     * checks if a shop is closed in a day
     * @param shopWorkingHours is the array of shop working hours
     * @param dateToCheck is the date to be checked
     * @returns true if the shop is closed
     */
    isShopClosed(shopWorkingHours: Array<any>, dateToCheck: Date = undefined): Boolean {
        const dayMap = { Mon: 'LU', Tue: 'MA', Wed: 'ME', Thu: 'GI', Fri: 'VE', Sat: 'SA', Sun: 'DO' };
        const workingDate = dateToCheck ? moment(dateToCheck) : moment();
        const currentTime = workingDate.format('HH:mm');
        const weekDay = dayMap[workingDate.format('ddd')];
        const openingTime = shopWorkingHours[weekDay];
        // check if we are in correct opening time
        return openingTime.length == 0 || openingTime[openingTime.length - 1].alle <= currentTime;
    }

    getSelectedLocale(): boolean {
        return this.selectedLocale;
    }

    setSelectedLocale(locale: boolean) {
        this.selectedLocale = locale;
    }

    makeCreditCardPayment(formData, paymentToken) {
        const headers = new Headers();
        headers.append('paymentToken', paymentToken);
        headers.append('Content-Type', 'application/json');

        return this.http.post(`${this.data.settings.sellaPaymentUrl}/v1/payment/submit`, formData, { headers: headers });
    }

    isFirstOrder(): boolean {
        return this.firstOrder;
    }

    setFirstOrder(first: boolean) {
        this.firstOrder = first;
    }

    getTotalFromServer(obj) {
        let headers = this.buildAuthHeaders();
        return this.http.post(this.customizer.getApiURL() + '/ordini/generateTotal', obj, { headers: headers });
    }

    getVariants(product) {
        // calcolo del massimo delle varianti selezionabili
        let varIngrGruppo = [];
        let varIngr = [];
        let variants = [];
    
        let materializeFunction = (itemId) => {
            varIngr.push(this.getProduct(itemId));
        };

        // extract UNIQUE (by using a set) variant IDS
        let variantIds = new Set(varIngrGruppo.concat(product.content.varIngr));
        variantIds.forEach((itemId) => materializeFunction(itemId));
    
        // process favorite variants or hidden ingredientes
        varIngr.forEach((variant) => {
            // process object
            if (!variant.extraProps.isIngrediente) {
                // favorite variants are inserted before normal one
                if (variant.isFavorite) variants.unshift(variant);
                else variants.push(variant);
            }
        });
        return variants;
    }

    /**
     * Get cart's product variants
     * @param product is the product on cart
     * @param productVariants is a specific structure to be used to match variants already added to product
     * @returns a structure containing 2 arrays of ingredients and product, and a max number of variants that can be added to product
     */
    getCartProductVariants(product: any, productVariants: any[] = undefined): ProductVariants {
        let result = new ProductVariants();
        // calcolo del massimo delle varianti selezionabili
        let varIngrGruppo = [];
        let varIngr = [];
        // lookup for product max vars
        if (product.content.extraProps.prodMaxVar) {
            result.max = product.content.extraProps.prodMaxVar;
        } else {
            // by default use settings from menu
            result.max = this.data.settings.prodMaxVar;
            // if parent is specified, use it
            if (product.parent) {
                const parent: any = this.getMenuRow(product.parent);
                if (parent.content.extraProps.prodMaxVar) result.max = parent.content.extraProps.prodMaxVar;
                // concat group variants too
                varIngrGruppo = varIngrGruppo.concat(parent.content.varIngr);
            }
        }

        // optimization: declare here the "materializeFunction" to handle standard case
        // get objects and deduplicate. consider product variant if requested
        let productVariantsById = {};
        let materializeFunction = (itemId) => {
            varIngr.push(this.getProduct(itemId));
        };
        // handle special case of item already in cart (which have a different structure)
        if (productVariants != undefined) {
            // populate array of references to product original variants
            productVariants.map((variant) => {
                productVariantsById[variant._id] = variant;
            });
            // optimization: redefine materialize function. So we execute
            // the check for productVariants for every item only if we need
            // it, while we use the previously defined function previously
            materializeFunction = (itemId) => {
                // use the product's already materialized item (which could be
                // customized by user) if its id is already used, otherwise we
                // get a new instance by the getProduct function
                if (productVariantsById.hasOwnProperty(itemId)) varIngr.push(productVariantsById[itemId]);
                else varIngr.push(this.getProduct(itemId));
            };
        }

        // extract UNIQUE (by using a set) variant IDS
        let variantIds = new Set(varIngrGruppo.concat(product.content.varIngr));
        variantIds.forEach((itemId) => materializeFunction(itemId));

        // process favorite variants or hidden ingredientes
        varIngr.forEach((variant) => {
            // process object
            if (variant.extraProps.isIngrediente && !this.data.settings.hideIngredients) result.ingredients.push(variant);
            else {
                // favorite variants are inserted before normal one
                if (variant.isFavorite) result.variants.unshift(variant);
                else result.variants.push(variant);
            }
        });

        // ingredienti e varianti divisi per tag
        if (product.content.extraProps.mandatoryIngredients && product.content.extraProps.mandatoryIngredients !== undefined) {
            result.mandatoryIngredients = product.content.extraProps.mandatoryIngredients;

            (result.mandatoryIngredients).map(item => {
                let varingr = [];
                varIngr.forEach(variant => {
                    if(variant.constraintTags) {
                        variant.constraintTags.forEach(tag => {
                            if (tag == item.tag) {
                                varingr.push(variant)
                            }
                        })
                    }
                })
                item.varIngr = varingr;
            });
            // process favorite variants or hidden ingredientes
            (result.mandatoryIngredients).forEach(element => {
                (element.varIngr).sort(function(x, y) {
                    // true values first
                    return (x.isFavorite === y.isFavorite) ? 0 : x ? -1 : 1;
                    // false values first
                    // return (x === y)? 0 : x? 1 : -1;
                });
            });

        }

        return result
    }

    /**
     * Filter price based on an hash of arrays indexed by price type (see sortCartItemVariants for costants)
     * @param element is the element to be filtered
     * @param targets is an associative array containing targets based on internal constants
     * @param explicitPrice is an optional price object to be used instead of element's one
     */
    private filterPrice(element: any, targets: {}, explicitPrice?: any) {
        if (element.quantita != 0) {
            const price = explicitPrice != undefined ? explicitPrice : element.prezzo;
            if (targets.hasOwnProperty(price.tipo)) targets[price.tipo].push(element);
            else console.log(`Missing target ${price.tipo} for ${element}`);
        }
    }

    /**
     * Sort cart item variants based on their type (used to correctly calculate price). See ProductVariants structure def.
     * @param context is the object ProductVariants used to pass references to local array for variants and ingredients
     * @returns an array containing, in order, direct price variants and percentage price variants
     */
    public sortCartItemVariants(context: ProductVariants): any[] {
        const DirectPrice = 1;
        const PercentagePrice = 2;

        let varianti = [],
            ingPerc = [],
            varPerc = [];

        // firstly ingredients
        context.ingredients.map((ingredient) => {
            this.filterPrice(ingredient, {
                [DirectPrice]: varianti,
                [PercentagePrice]: ingPerc,
            });
        });

        // then variants
        context.variants.map((variant) => {
            // transform single prices into array to use filter after
            let prices = variant.prezzo;
            if (variant.prezzo.length == undefined) prices = [variant.prezzo];
            // filter only variants applied as variants and not product
            prices
                .filter((price) => price.when == 'var')
                .map((price) => {
                    this.filterPrice(
                        variant,
                        {
                            [DirectPrice]: varianti,
                            [PercentagePrice]: varPerc,
                        },
                        price
                    );
                });
        });

        // return, in order, variants and percentage variants.
        // TODO - Percentage ingredients ? where are they ?
        return varianti.concat(varPerc);
    }

    getGestPayOrderStatus(orderId) {
        const headers = this.buildAuthHeaders();
        const url = `${this.customizer.getApiURL()}/ordini/${orderId}/gestpay-payment-status`;

        return this.http.get(url, { headers: headers });
    }

    getNexiOrderStatus(orderId) {
        const headers = this.buildAuthHeaders();
        const url = `${this.customizer.getApiURL()}/ordini/${orderId}/nexi-payment-status`;

        return this.http.get(url, { headers: headers });
    }

    /** 
     * Salva la data scelta dal cliente
     * @param data è la data scelta
     */
    public setDateForTakeAwayOrDelivery(data: string) {
        this.chosenDate = data;
    }

    /** 
     * Ritorna la data scelta precedentemente dal cliente
     * @returns la data scelta
     */
    public getDateForTakeAwayOrDelivery() {
        return this.chosenDate;
    }

    // salva un boolean se la carta fedeltà è attiva per questo esercizio
    public setPrepaidCard(data: boolean) {
        this.prepaidcard = data;
    }

    // ritorna un boolean se la carta fedeltà è attiva per questo esercizio
    public getPrepaidCard() {
        return this.prepaidcard;
    }

    // salva un boolean se i coupon sono attivi per questo esercizio
    public setCoupon(data: boolean) {
        this.coupon = data;
    }

    // ritorna un boolean se i coupon sono attivi per questo esercizio
    public getCoupon() {
        return this.coupon;
    }

    // ritorna i coupon attivi dato l'id del cliente
    public getCoupons(id) {
        const headers = this.buildAuthHeaders();
        const url = `${this.customizer.getApiURL()}/coupon/byUser/`+id;

        return this.http.get(url, { headers: headers });
    }

    // salva i coupon attivati dal cliente
    public setAppliedCoupons(data) {
        this.couponsApplied = data;
    }

    // ritorna i coupon attivati dal cliente
    public getAppliedCoupons() {
        return this.couponsApplied;
    }
}



// WEBPACK FOOTER //
// ./src/providers/provider.ts